import axios, { InternalAxiosRequestConfig, AxiosResponse, AxiosError, AxiosHeaders } from 'axios';
import { config } from '@/config/config';
import { getLocalStorageItem, handleLogout } from '@/utils/helpers';
import { getState } from '@/store/store';

interface CustomAxiosRequestConfig extends InternalAxiosRequestConfig {
  ignoreToken?: boolean;
}

interface ThemeOptionsState {
  selectedVenue: {
    id: string;
  } | null;
}

const AxiosInterceptor = {
  initialize: (): void => {
    axios.defaults.baseURL = config.backendUrl;

    axios.interceptors.request.use(
      (axiosConfig: InternalAxiosRequestConfig) => {
        const authToken = getLocalStorageItem<string>('authentication_token');
        if (authToken && !(axiosConfig as CustomAxiosRequestConfig).ignoreToken) {
          const headers = new AxiosHeaders(axiosConfig.headers);
          headers.set('Authorization', `Bearer ${authToken}`);
          headers.set('Selected-Venue', (getState().ThemeOptions as ThemeOptionsState).selectedVenue?.id ?? 'head_office');
          axiosConfig.headers = headers;
        }
        if (!axiosConfig.headers?.get('Content-Type')) {
          const headers = new AxiosHeaders(axiosConfig.headers);
          headers.set('Content-Type', 'application/json');
          axiosConfig.headers = headers;
        }
        return axiosConfig;
      },
      (error: AxiosError) => {
        return Promise.reject(error);
      },
    );

    axios.interceptors.response.use(
      (response: AxiosResponse) => {
        return response.data;
      },
      (error: AxiosError) => {
        if (error.response?.status === 401) {
          handleLogout();
        }
        return Promise.reject(error);
      },
    );
  },
};

export default AxiosInterceptor;
